
import {headerMenumapping} from "./headerMenumapping";

type permissionMapping = {
    [key: string]: {
        controller: string;
        function: string;
    };
};

// Merge both mappings
const PERMISSION_MAPPINGS: permissionMapping = {
    ...headerMenumapping,

};

export function getPermissionMapping(key: string) {
    return PERMISSION_MAPPINGS[key] || null;
}
